import React from "react";
import { motion } from "framer-motion";
import { SITE } from "@/constants/testIds";

const STATS = [
  { n: "1600+", l: "Projects Delivered" },
  { n: "300+", l: "Clients Served" },
  { n: "700+", l: "Creative Partners" },
  { n: "2020", l: "Started In Bangalore" },
];

export default function Proof() {
  return (
    <section data-testid={SITE.proofSection} className="bg-relatable text-bone py-20 md:py-24 overflow-hidden relative">
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(transparent 0, transparent 47px, rgba(255,255,255,0.4) 48px), linear-gradient(90deg, transparent 0, transparent 47px, rgba(255,255,255,0.4) 48px)",
          backgroundSize: "48px 48px",
        }} />
      <div className="relative px-6 md:px-12 lg:px-24">
        <p className="eyebrow text-bone/70 mb-10">◐ Proof — Since 2020</p>
        <h2 className="font-display text-bone text-5xl md:text-7xl lg:text-8xl tracking-tighter font-medium leading-[0.95] max-w-5xl">
          Numbers we&rsquo;ve earned.<br/>Not numbers we like.
        </h2>

        <div className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-4 gap-y-12 md:gap-y-0 md:gap-x-6 border-t border-bone/30 pt-12">
          {STATS.map((s, i) => (
            <motion.div
              key={s.l}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.6 }}
              className="border-l border-bone/20 pl-6 first:border-l-0 first:pl-0 md:border-l md:pl-6"
            >
              <p className="font-display text-bone text-6xl md:text-7xl lg:text-8xl tracking-tighter font-medium leading-none">
                {s.n}
              </p>
              <p className="mt-4 eyebrow text-bone/85">{s.l}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
